module.exports = __webpack_public_path__ + "static/media/27.3f32ba43.webp";